<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <paginated-table
          :title="tableTitle"
          :icon="tableIcon"
          :columns="columns"
          :data="finalReviews"
          @updatePagination="updatePagination"
        ></paginated-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";

import { getFinalReviewStatusColumns } from "@/views/FinalReviewView/columns";
import { finalReviewApi } from "@/api/api";
import { finalReviewStatusLabel } from "@/views/FinalReviewView/label";

export default {
  components: {
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      tableTitle: finalReviewStatusLabel.tableTitle,
      tableIcon: "manage_search",
      isLoading: false,
      finalReviews: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 5,
          total_pages: 1,
        },
        elements: [],
      },
      columns: getFinalReviewStatusColumns({
        edit: this.toEditReview,
        description: this.toDetail,
      }),
    };
  },
  methods: {
    /**
     * 수정 작업 처리 메소드
     */
    toEditReview(finalReview) {
      if (finalReview.status === "COMPLETED") {
        this.notifyVue({
          message: "이미 완료된 총평입니다.",
          style: "warning",
        });
        return;
      } else {
        this.$router.push({
          name: "final-review-edit",
          params: {
            idx: finalReview.idx,
          },
        });
      }
    },
    toDetail(data) {
      this.$router.push(`/final-reviews/detail/${data.idx}`);
    },
    /**
     * 총평 목록 조회 API 요청 메서드
     */
    fetchFinalReviews(size, page) {
      const params = {
        size: size,
        page: page,
        sort_by: "idx",
        direction: "desc",
      };

      this.isLoading = true;
      finalReviewApi.getFinalReviews(params).then((response) => {
        if (response && response.status === 200) {
          this.finalReviews = response.data.response;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.notifyVue({
            message: finalReviewStatusLabel.apiRequestFailMessage,
            style: "danger",
          });
        }
      });
    },
    /**
     * Pagination 타입 명세
     * @typedef {Object} Conditions
     * @property {string} page - 페이지
     * @property {string} size - 사이즈
     * @property {string} total_elements - 전체 데이터 수
     * @property {string} total_pages - 전체 페이지 수
     */

    /**
     * 페이지네이션 업데이트 메서드
     *
     * @description: 페이징 정보가 변경되면 하위 컴포넌트에서 정보를 받아 업데이트 및 API 요청
     * @params {Pagination} pagination
     */
    updatePagination(pagination) {
      this.finalReviews.page_info.size = pagination.size;
      this.finalReviews.page_info.page = pagination.page;

      this.fetchFinalReviews(
        this.finalReviews.page_info.size,
        this.finalReviews.page_info.page
      );
    },
    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  mounted() {
    this.fetchFinalReviews(
      this.finalReviews.page_info.size,
      this.finalReviews.page_info.page
    );
  },
};
</script>
<style scoped></style>
